import { Dispatch, SetStateAction, useState } from 'react';
import { usePrevious } from './usePrevious';
import { shallowEqual } from './useShallowMemo';

/**
 * Este hook permite mantener un estado interno en un componente, al mismo tiempo que se escucha el estado externo a través de las props, permitiendo la edición del valor en forma interna, a la vez que se permite su definición desde los padres del componente.
 *
 * Es útil especialmente en campos de tipo input en los cuales es deseable permitir al usuario escribir libremente, y luego de validada la entrada, establecer un valor diferente para mostrar.
 */
export function useIntermediateValue<T>(
  currentValue: T,
): [T, Dispatch<SetStateAction<T>>] {
  const [innerState, setInnerState] = useState<T>(currentValue);

  const previousValue = usePrevious(currentValue);
  if (!shallowEqual(currentValue, previousValue.current)) {
    setInnerState(currentValue);
  }

  return [innerState, setInnerState];
}
